/*
 * @Author: lan.h
 * @Date: 2021-10-19 16:02:36
 * @LastEditors: lan.h
 * @LastEditTime: 2021-11-26 09:20:13
 * @Description: 接口文档
 */
import axios_req from '../axios'

let getMeta =  (data, cb) => axios_req('post','/meta/getMeta', data, cb)// 获取字典
let getAwardsYearList =  (data, cb) => axios_req('post','/vb100/getAwardsYearList', data, cb)// 年份下所有榜单数据接口
let getCompanyNewsList = (data, cb) => axios_req('post','/vb100/getCompanyNewsList', data, cb)// 企业动态列表
let getVbArticleType = (data, cb) => axios_req('post','/vb100/getVbArticleType', data, cb)// 企业动态-文章类型
let getVbTopYearList = (data, cb) => axios_req('post','/vb100/getVbTopYearList', data, cb)// 榜单年份
let getPeopleVisit = (data, cb) => axios_req('post','/vb100/getPeopleVisit', data, cb)// 人物动态
let getVbRegistrationList = (data, cb) => axios_req('post', '/vb100/getVbRegistrationList', data, cb) //未发布

let getVbTopListByYear = (data, cb) => axios_req('post','/vb100/getVbTopListByYear', data, cb)// 年份下所有的榜单接口
let getVbTopListById = (data, cb) => axios_req('post','/vb100/getVbTopListById', data, cb)// 年份下所有的榜单接口
let getSupportOrganizationYear = (data, cb) => axios_req('post','/vb100/getSupportOrganizationYear', data, cb)// 有支持机构的年份接口
let getSupportOrganization = (data, cb) => axios_req('post','/vb100/getSupportOrganization', data, cb)// 支持机构列表接口
let getReportTag = (data, cb) => axios_req('post','/vb100/getReportTag', data, cb)// 报告关联的所有标签接口
let getVBBannerList = (data, cb) => axios_req('post','/vb100/getVBBannerList', data, cb)// banner图接口
let getReportList = (data, cb) => axios_req('post','/vb100/getReportList', data, cb)// 报告列表接口
let getVb100EnrollLink = (data, cb) => axios_req('post', '/vb100/getVb100EnrollLink', data, cb) //榜单报名链接
let getDeclarationInstructions = (data, cb) => axios_req('post', '/vb100/getDeclarationInstructions', data, cb) //vb100榜单申报须知接口

export {
  getMeta, getAwardsYearList, getCompanyNewsList, getVbTopListByYear, getVbTopListById, getVbArticleType, getVbTopYearList, getPeopleVisit, getVbRegistrationList,
  getSupportOrganizationYear, getSupportOrganization, getReportTag, getVBBannerList, getReportList, getVb100EnrollLink, getDeclarationInstructions
}